import { take, fork } from 'redux-saga/effects';
import {
  ADD_FAVOURITE,
  GET_FAVOURITES,
  GET_FAVOURITES_ERROR,
  GET_FAVOURITES_SUCCESS, REMOVE_FAVOURITE,
  SET_FAVOURITES
} from '@flow/store/user/constants';
import gql from 'graphql-tag';
import { requestData } from '@flow/store/flows/request-data';
import { getFavourites } from '@flow/graphql/queries';
import { addFavouriteFlow } from '@flow/store/user/flows/add-favourite-flow';
import { removeFavouriteFlow } from '@flow/store/user/flows/remove-favourite-flow';
import { setFavouritesFlow } from '@flow/store/user/flows/set-favourites-flow';

export default function* userWatcher(): any {
  while (true) {
    const {
      type,
      params,
      onComplete
    } = yield take([
      GET_FAVOURITES,
      SET_FAVOURITES,
      ADD_FAVOURITE,
      REMOVE_FAVOURITE
    ]);

    switch (type) {
      case GET_FAVOURITES:
        yield fork(requestData(gql(getFavourites), GET_FAVOURITES_SUCCESS, GET_FAVOURITES_ERROR), {}, onComplete);
        break;

      case SET_FAVOURITES:
        yield fork(setFavouritesFlow, params.favourites, onComplete);
        break;

      case ADD_FAVOURITE:
        yield fork(addFavouriteFlow, params.favourite, onComplete);
        break;

      case REMOVE_FAVOURITE:
        yield fork(removeFavouriteFlow, params.programId, onComplete);
        break;
    }
  }
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/sagas.ts